import { useContext, useState } from "react"
import getServices from "../services/getServices"
import postService from "../services/postService"
import { AuthContext } from "../contexts/auth"
import toast from "react-hot-toast"

const useRelatoriosState = () => {

    const { signOut, user } = useContext(AuthContext)
    const [openDialog, setOpenDialog] = useState(false)

    const [templateDeletar, setTemplateDeletar] = useState(false)
    const [pesquisa, setPesquisa] = useState('')
    const [registros, setRegistros] = useState([])
    const [submit, setSubmit] = useState(false)

    const _getRegistros = async ()=>{
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await getServices('admin/relatorio/', pesquisa === '' ? null: pesquisa)
        if (result.type === 'success'){
            setRegistros(result.data)
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }
        else if (result.type === 'error'){
            toast.error('Erro ao buscar registros')
        }                
        setSubmit(false)
    }

    const gerarRelatorio = async (data) => {
        if (submit){
            return;
        }
        setSubmit(true)
        let result = await postService('admin/relatorio/', data)
        if (result.type === 'success'){
            _getRegistros()
        }
        else if (result.data?.code === 'token_not_valid'){
            signOut()
        }   
        else if (result.type === 'error'){
            toast.error(result.data.detail || 'Erro ao gerar relatório')
        }                

        setSubmit(false)
    }

    return {
        
        registros: {value: registros, set:_getRegistros},
        pesquisa: {value: pesquisa, set:setPesquisa},
        openDialog: {value: openDialog, set:setOpenDialog},
        deletar: {value: ()=>{console.log('não implementado')}, set: ()=>{console.log('não implementado')}},
        itemDelete:{value:templateDeletar, set:setTemplateDeletar},  
        submit: {value: submit, set: _getRegistros},
        gerarRelatorio: {value: submit, set: gerarRelatorio},
    }
}

export default useRelatoriosState